import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  label: string;
  color?: string;
  icon?: React.ReactNode;
}

export const BadgeItem = (props: Props) => {
  return (
    <ChakraV3.Badge px={2} py={0.5} colorPalette={props.color} rounded='md'>
      <ChakraV3.HStack align='center' lineHeight='normal'>
        {props.icon && props.icon}
        {props.label}
      </ChakraV3.HStack>
    </ChakraV3.Badge>
  );
};
